// todo: 页面的自适应、详情页
import { useState, useEffect, useMemo, useCallback, useRef } from 'react'
import Head from 'next/head'
import Script from 'next/script'
import dynamic from 'next/dynamic'
import {
  GlobalOutlined,
  PhoneOutlined,
  MailOutlined,
  EnvironmentOutlined,
  FileImageOutlined,
  LeftOutlined,
  RightOutlined,
  QuestionCircleFilled,
  EllipsisOutlined,
  FormOutlined
} from '@ant-design/icons'
// import { Document } from 'react-pdf'
import styles from './index.module.scss'
// import Image from 'next/image'
// import Router from 'next/router'
import {
  message,
  Rate,
  Button,
  Table,
  Tabs,
  Collapse,
  Carousel,
  Modal,
  Input,
  Image,
  notification,
  Form,
  Row,
  Col,
  Tag
} from 'antd'
import GoogleMap from 'google-map-react'
import 'react-quill/dist/quill.snow.css'
import { request, isOnlineDev } from '@utils'
import { setSignShow } from '@store/authSlice'
import { useSelector, useDispatch } from 'react-redux'
import { EmbedPDF } from '@simplepdf/react-embed-pdf'

import Calendar from './components/calendar'
import Claim from './components/claim'
import Table2phone from './components/table2phone'
// import useMobileDetect from '@/utils/isMobile'

const { Panel } = Collapse
const scheduleKeys = [
  'home_based',
  'elementary',
  'nido',
  'primary',
  'toddler',
  'middle',
  'high'
]

const ReactQuill = dynamic(() => import('react-quill'), { ssr: false })
// const PdfViewer = dynamic(() => import('../../components/Pdf'), { ssr: false })
// pdfjs.GlobalWorkerOptions.workerSrc = require('pdfjs-dist/build/pdf.worker.min.js')

const Maker = (props) => (
  <div className={styles.maker}>
    <div className={styles.makerPoint}>
      <img
        style={{ width: 32, height: 32 }}
        alt="google position"
        src={
          props.active
            ? '/position-active.png'
            : props.$hover
            ? '/position-hover.png'
            : '/position.png'
        }
      ></img>
    </div>
  </div>
)

// 获取每个锚点的scrollTop，实时监控滚动条，当它大于等于某个并且小于下一个时，设置active
const defaultAnchorList = [
  {
    id: 'About',
    title: 'About',
    top: 0
  },
  {
    id: 'Destination',
    title: 'Description',
    top: 0
  },
  {
    id: 'General',
    title: 'General Information',
    top: 0
  },
  {
    id: 'Daily',
    title: 'Daily Schedule',
    top: 0
  },
  {
    id: 'AllAbout',
    title: 'Fees & Discounts',
    top: 0
  },
  {
    id: 'Schedules',
    title: 'Schedules Available',
    top: 0
  },
  {
    id: 'Offered',
    title: 'Programs Offered',
    top: 0
  },
  {
    id: 'Calender',
    title: 'School Calendar',
    top: 0
  },
  {
    id: 'Review',
    title: 'Reviews',
    top: 0
  }
]

const dealAgeMin = (age) => {
  if (age < 2) {
    // age乘以12不是整数，要用周显示（乘以4）
    const m = age * 12
    if (m > 3) {
      return `${Math.ceil(m)} mo.`
    } else {
      return `${Math.ceil(+m.toFixed(2) * 4)} weeks`
    }
  }
  return `${age}`
}

const SlickButtonFix = ({ currentSlide, slideCount, children, ...props }) => (
  <span {...props}>{children}</span>
)

const standardTestingKeys = ['home_based', 'nido', 'toddler', 'primary']

export default function SchoolId(props) {
  const [detail, setDetail] = useState(props.detail || {})
  const [reviews, setReviews] = useState(props.reviews)
  const [yelpReviews] = useState(props.yelpReviews)
  const [yelpReviewList, setYelpReviewList] = useState(
    props.yelpReviews.data || []
  )
  const [yelpCurrent, setYelpCurrent] = useState(0)
  const [googleReviews] = useState(props.googleReviews)
  const [googleReviewList] = useState(props.googleReviews.data || [])
  const [reviewVisible, setReviewVisible] = useState(false)
  const [value, setValue] = useState('')
  const [reviewScore, setReviewScore] = useState(0)
  const [author, setAuthor] = useState(null)
  // const [activeWatchImg, setActiveWatchImg] = useState('')
  const [activeWatchImgVisible, setActiveWatchImgVisible] = useState(false)
  const [reviewPage, setReviewPage] = useState(1)
  // const [email, setEmail] = useState('')
  const [tourVisible, setTourVisible] = useState(props.tourVisible)
  const [tel, setTel] = useState('')
  const [anchorList, setAnchorList] = useState(defaultAnchorList)
  const [nowScrollTop, setNowScrollTop] = useState(0)
  const [requestVisible, setRequestVisible] = useState(false)
  const [claimShow, setClaimShow] = useState(false)
  const [scheduleCancel, setScheduleCancel] = useState(props.scheduleCancel)
  const [scheduleReset, setScheduleReset] = useState(props.scheduleReset)
  const [isSave, setIsSave] = useState(false)
  const [updateSaveDate, setUpdateSaveDate] = useState(Date.now())
  const [updateChildrenDate, setUpdateChildrenDate] = useState(Date.now())
  const [postting, setPostting] = useState(false)
  const [schoolIndex, setSchoolIndex] = useState(0)
  const [isPhone, setIsPhone] = useState(false)

  const isShowCalendar = detail.schedule_type === 2

  const isClaimed = useMemo(() => {
    return detail.verify === 'Claimed'
  }, [detail])

  const userInfo = useSelector((state) => state.auth.userInfo)
  useEffect(() => {
    if (userInfo && userInfo.schools) {
      setSchoolIndex(userInfo.schools.map((_) => _.url).indexOf(props.id))
    }
  }, [userInfo])
  const dispatch = useDispatch()

  const formRef = useRef(null)
  const tourRef = useRef(null)

  const onListenerScrollTop = () => {
    setNowScrollTop(document.body.scrollTop)
  }

  useEffect(() => {
    window.addEventListener('scroll', onListenerScrollTop, true)
    const data = anchorList.map((_) => {
      const $ = document.getElementById(_.id)
      let top = 0
      if ($) {
        top = $.offsetTop
      }
      return { ..._, top }
    })
    setAnchorList(
      data.filter((_) => {
        switch (_.title) {
          case 'Daily Schedule':
            return !isEmpty([
              'lunch_provided',
              'snack_provided',
              'outside_playtime',
              'naptime',
              'daily_updates',
              'after_school_program',
              'enrichment_classes'
            ])
          case 'Fees & Discounts':
            return !isEmpty(['discount', 'fees'])
          case 'School Calendar':
            return detail.school_calendar !== ''
          default:
            return true
        }
      })
    )
    // setIsPhone(useMobileDetect().isMobile())
    return () => window.removeEventListener('scroll', onListenerScrollTop)
  }, [])

  // 存在预约取消、预约重选需要自动打开预约
  useEffect(() => {
    if (props.scheduleCancel || props.scheduleReset) {
      setTourVisible(true)
    }
  }, [props.scheduleCancel, props.scheduleReset])

  // 获取收藏状态
  useEffect(() => {
    if (userInfo && userInfo.id) {
      request
        .get('/api/school/is-save', { params: { school_id: detail.id } })
        .then((r) => {
          setIsSave(r.data ? r.data.status === 1 : false)
        })
    }
  }, [updateSaveDate, userInfo])

  const id = detail.id

  // 判断Schedule的最大天数
  const scheduleDay = (key) => {
    let day = []
    const keys = new Array(4)
      .fill(0)
      .map((_, i) => `tuition_${key}_${i + 2}_day_per_week`)
    for (let index = 0; index < scheduleKeys.length; index++) {
      const key = scheduleKeys[index]
      for (let i2 = 0; i2 < keys.length; i2++) {
        const k2 = keys[i2]
        if (
          detail[key] &&
          detail[key][k2] &&
          (detail[key][k2] !== 0 || detail[key][k2] !== '')
        ) {
          day.push(+k2.replace(/\D/g, ''))
        }
      }
    }
    return day
  }

  const renderContentAutoLineFeed = (text) => {
    let t = ''
    if (text && text.replace) {
      t = text.replace(/;/g, '<br />')
      if (t.replace) {
        t = t.replace(/\n/g, '<br />')
      }
    }

    return t && t !== '' ? (
      <span
        dangerouslySetInnerHTML={{
          __html: t
        }}
      ></span>
    ) : (
      '-'
    )
  }

  const schedulesAvalibleColumns = useMemo(() => {
    return [
      {
        title: 'Schedule',
        dataIndex: 'schedule',
        align: 'center'
      },
      {
        title: 'Time',
        dataIndex: 'time',
        width: 230,
        align: 'center'
      },
      {
        title: '2 Days',
        dataIndex: 'day2',
        align: 'center',
        render(t) {
          return <span style={{ color: '#51b8b4' }}>{t}</span>
        }
      },
      {
        title: '3 Days',
        dataIndex: 'day3',
        align: 'center',
        render(t) {
          return <span style={{ color: '#51b8b4' }}>{t}</span>
        }
      },
      {
        title: '4 Days',
        dataIndex: 'day4',
        align: 'center',
        render(t) {
          return <span style={{ color: '#51b8b4' }}>{t}</span>
        }
      },
      {
        title: '5 Days',
        dataIndex: 'day5',
        align: 'center',
        render(t) {
          return <span style={{ color: '#51b8b4' }}>{t}</span>
        }
      }
    ]
  }, [])

  const schedulesAvalibleDataSource = useMemo(() => {
    let half_day = []
    let full_day = []
    // if (detail.home_based_age) {
    //   const halfArr = [
    //     'home_based_tuition_half_day_2_day_per_week',
    //     'home_based_tuition_half_day_3_day_per_week',
    //     'home_based_tuition_half_day_4_day_per_week',
    //     'home_based_tuition_half_day_5_day_per_week'
    //   ]
    //   const fullArr = [
    //     'home_based_tuition_full_day_2_day_per_week',
    //     'home_based_tuition_full_day_3_day_per_week',
    //     'home_based_tuition_full_day_4_day_per_week',
    //     'home_based_tuition_full_day_5_day_per_week'
    //   ]
    //   for (let index = 0; index < halfArr.length; index++) {
    //     const key = halfArr[index]
    //     if (detail[key]) {
    //       half_day.push(+key.replace(/\D/g, ''))
    //     }
    //   }
    //   for (let index = 0; index < fullArr.length; index++) {
    //     const key = fullArr[index]
    //     if (detail[key]) {
    //       full_day.push(+key.replace(/\D/g, ''))
    //     }
    //   }
    // }
    const half_days = scheduleDay('half_day')
    const full_days = scheduleDay('full_day')
    const extended_schedules = scheduleDay('extended_schedule')
    return [
      {
        schedule: 'Half Day',
        time: detail.half_day_schedule || '-',
        day2: half_days.indexOf(2) > -1 ? '●' : '',
        day3: half_days.indexOf(3) > -1 ? '●' : '',
        day4: half_days.indexOf(4) > -1 ? '●' : '',
        day5: half_days.indexOf(5) > -1 ? '●' : ''
      },
      {
        schedule: 'Full Day',
        time: detail.full_day_schedule || '-',
        day2: full_days.indexOf(2) > -1 ? '●' : '',
        day3: full_days.indexOf(3) > -1 ? '●' : '',
        day4: full_days.indexOf(4) > -1 ? '●' : '',
        day5: full_days.indexOf(5) > -1 ? '●' : ''
      },
      {
        schedule: 'Extended Schedule',
        time: detail.extended_schedule || '-',
        day2: extended_schedules.indexOf(2) > -1 ? '●' : '',
        day3: extended_schedules.indexOf(3) > -1 ? '●' : '',
        day4: extended_schedules.indexOf(4) > -1 ? '●' : '',
        day5: extended_schedules.indexOf(5) > -1 ? '●' : ''
      }
    ]
  }, [detail, scheduleDay])

  const getProramsDetail = (key, ckey) => {
    return detail[key] && detail[key][ckey]
      ? renderContentAutoLineFeed(detail[key][ckey])
      : '-'
  }

  const proramsColumns = useMemo(() => {
    return [
      {
        title: 'Schedule',
        dataIndex: 'schedule',
        align: 'center'
      },
      {
        title: 'Time',
        dataIndex: 'time',
        width: 150,
        align: 'center'
      },
      {
        title: '2 Days',
        dataIndex: 'day2',
        align: 'center',
        render: (_) =>
          _ !== '-' ? (
            +detail.hide_tuition_info ? (
              <a onClick={() => setRequestVisible(true)}>Request Rate</a>
            ) : (
              renderContentAutoLineFeed(_)
            )
          ) : (
            '-'
          )
      },
      {
        title: '3 Days',
        dataIndex: 'day3',
        align: 'center',
        render: (_) =>
          _ !== '-' ? (
            +detail.hide_tuition_info ? (
              <a onClick={() => setRequestVisible(true)}>Request Rate</a>
            ) : (
              renderContentAutoLineFeed(_)
            )
          ) : (
            '-'
          )
      },
      {
        title: '4 Days',
        dataIndex: 'day4',
        align: 'center',
        render: (_) =>
          _ !== '-' ? (
            +detail.hide_tuition_info ? (
              <a onClick={() => setRequestVisible(true)}>Request Rate</a>
            ) : (
              renderContentAutoLineFeed(_)
            )
          ) : (
            '-'
          )
      },
      {
        title: '5 Days',
        dataIndex: 'day5',
        align: 'center',
        render: (_) =>
          _ !== '-' ? (
            +detail.hide_tuition_info ? (
              <a onClick={() => setRequestVisible(true)}>Request Rate</a>
            ) : (
              renderContentAutoLineFeed(_)
            )
          ) : (
            '-'
          )
      }
    ]
  }, [detail])

  const getProramsDataSource = (key) => {
    function formatNumberWithCommas(number) {
      const parts = number.toString().split('.')
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      return parts.join('.')
    }
    const getData = (key, ckey) => {
      return detail[key] && detail[key][ckey]
        ? ckey.indexOf('tuition') > -1
          ? '$' + formatNumberWithCommas(+detail[key][ckey])
          : detail[key][ckey]
        : '-'
    }
    return [
      {
        schedule: 'Half Day',
        time: getData(key, 'half_day_schedule') || '-',
        day2: getData(key, 'tuition_half_day_2_day_per_week') || '-',
        day3: getData(key, 'tuition_half_day_3_day_per_week') || '-',
        day4: getData(key, 'tuition_half_day_4_day_per_week') || '-',
        day5: getData(key, 'tuition_half_day_5_day_per_week') || '-'
      },
      {
        schedule: 'Full Day',
        time: getData(key, 'full_day_schedule') || '-',
        day2: getData(key, 'tuition_full_day_2_day_per_week') || '-',
        day3: getData(key, 'tuition_full_day_3_day_per_week') || '-',
        day4: getData(key, 'tuition_full_day_4_day_per_week') || '-',
        day5: getData(key, 'tuition_full_day_5_day_per_week') || '-'
      },
      {
        schedule: 'Extended Schedule',
        time: getData(key, 'extended_schedule') || '-',
        day2: getData(key, 'tuition_extended_schedule_2_day_per_week') || '-',
        day3: getData(key, 'tuition_extended_schedule_3_day_per_week') || '-',
        day4: getData(key, 'tuition_extended_schedule_4_day_per_week') || '-',
        day5: getData(key, 'tuition_extended_schedule_5_day_per_week') || '-'
      }
    ]
  }

  const getHomeBasedDataSource = (d) => {
    return [
      {
        schedule: 'Half Day',
        time: d['half_day_schedule'] || '-',
        day2: d['home_based_tuition_half_day_2_day_per_week'] || '-',
        day3: d['home_based_tuition_half_day_3_day_per_week'] || '-',
        day4: d['home_based_tuition_half_day_4_day_per_week'] || '-',
        day5: d['home_based_tuition_half_day_5_day_per_week'] || '-'
      },
      {
        schedule: 'Full Day',
        time: d['full_day_schedule'] || '-',
        day2: d['home_based_tuition_full_day_2_day_per_week'] || '-',
        day3: d['home_based_tuition_full_day_3_day_per_week'] || '-',
        day4: d['home_based_tuition_full_day_4_day_per_week'] || '-',
        day5: d['home_based_tuition_full_day_5_day_per_week'] || '-'
      }
    ]
  }

  const renderPannel = useMemo(() => {
    const keys = [
      'home_based',
      'nido',
      'toddler',
      'primary',
      'elementary',
      'middle',
      'high'
    ]
    return keys &&
      keys.filter((_) => getProramsDetail(_, 'age') !== '-').length ? (
      <Collapse defaultActiveKey={[]} style={{ width: '100%' }}>
        {keys
          .filter((_) => getProramsDetail(_, 'age') !== '-')
          .map((_, i) => (
            <Panel
              header={
                <div>
                  <span style={{ textTransform: 'capitalize' }}>{_}</span>{' '}
                  Program ({getProramsDetail(_, 'age')})
                </div>
              }
              key={i}
            >
              <div className={styles.itemBoxContentTable}>
                <div className={styles.itemBoxContentTableTitle}>
                  Schedules and Tuition Infomation
                </div>
                {isPhone ? (
                  <Table2phone
                    columns={proramsColumns}
                    dataSource={getProramsDataSource(_)}
                  />
                ) : (
                  <Table
                    style={{ width: '100%' }}
                    bordered
                    columns={proramsColumns}
                    dataSource={getProramsDataSource(_)}
                    pagination={false}
                    rowKey="schedule"
                  ></Table>
                )}
              </div>
              <div className={styles.itemBoxContentTable}>
                <div className={styles.itemBoxContentTableTitle}>
                  Programs Details
                </div>
                <div className={styles.itemBoxContentTableBox}>
                  <div className={styles.itemBoxContentTableBoxText}>
                    <span>Teacher Student Ratio</span>
                    <span>{getProramsDetail(_, 'teacher_student_ratio')}</span>
                  </div>
                  <div className={styles.itemBoxContentTableBoxText}>
                    <span>Classroom Size</span>
                    <span>{getProramsDetail(_, 'classroom_size')}</span>
                  </div>
                  <div className={styles.itemBoxContentTableBoxText}>
                    <span>Number of Classroom</span>
                    <span>{getProramsDetail(_, 'number_of_classroom')}</span>
                  </div>
                  <div className={styles.itemBoxContentTableBoxText}>
                    <span>
                      {standardTestingKeys.indexOf(_) > -1
                        ? 'Potty training requirement'
                        : 'Standard Testing Requirement'}
                    </span>
                    <span>
                      {getProramsDetail(_, 'potty_training_requirement')}
                    </span>
                  </div>
                  <div className={styles.itemBoxContentTableBoxText}>
                    <span>Bilingual Program</span>
                    <span>{getProramsDetail(_, 'bilingual_program')}</span>
                  </div>
                  <div className={styles.itemBoxContentTableBoxText}>
                    <span>Daily Schedule Detail</span>
                    <span>{getProramsDetail(_, 'daily_schedule_detail')}</span>
                  </div>
                </div>
              </div>
            </Panel>
          ))}
      </Collapse>
    ) : (
      <div className="no-content">No Content</div>
    )
  }, [detail, isPhone])

  const countReviewLength = (count) => {
    return +detail.review_count ? Math.floor(+count / +detail.review_count) : 0
  }

  const getReviewCount = (a, b) => {
    return detail.review_scores
      ? detail.review_scores[a].count + detail.review_scores[b].count
      : 0
  }

  const getRivewList = (isMore) => {
    let page = 1
    if (isMore) {
      page = reviewPage + 1
      setReviewPage(page)
    } else {
      setReviewPage(1)
    }
    request
      .get(`/api/review/list?school_id=${id}&per_page=10&page=${page}`)
      .then(({ data }) => {
        if (isMore) {
          let reviews2 = reviews.data
          let data2 = data
          data2.data = reviews2.concat(data.data)
          setReviews(data2)
        } else {
          setReviews(data)
        }
      })
  }

  const getYelpReview = () => {
    request
      .get(
        `/api/review/list?school_id=${id}&per_page=1&page=${
          yelpReviewList ? yelpReviewList.length + 1 : 10
        }&source=1`
      )
      .then(({ data }) => {
        setYelpReviewList([...yelpReviewList, ...data.data])
      })
  }

  const getDetail = () => {
    request.get(`/api/school/detail?id=${id}`).then((r) => {
      setDetail(r.data)
    })
  }

  const reviewModalOpt = {
    title: 'Add a review',
    open: reviewVisible,
    width: 800,
    onCancel() {
      setReviewVisible(false)
    },
    onOk() {
      if (!reviewScore || !value || !author) {
        message.error('Please fill in the complete content!')
        return false
      }
      return new Promise((res, rej) => {
        request({
          method: 'post',
          url: '/api/review/add',
          data: {
            school_id: id,
            score: reviewScore * 2,
            content: value,
            author_name: author
          }
        }).then((r) => {
          if (r.code === 0) {
            setReviewVisible(false)
            getRivewList(false)
            getDetail()
            res(true)
          } else {
            message.error(r.msg)
            rej(false)
          }
        })
      })
    }
  }

  const tourModalOpt = {
    title: 'Schedule A Tour',
    open: tourVisible,
    width: isShowCalendar ? (props.scheduleCancel ? 925 : 1200) : 900,
    confirmLoading: postting,
    onCancel() {
      setTourVisible(false)
      setUpdateChildrenDate(Date.now())
    },
    onOk() {
      // if (!tel || !email || !isEmail(email) || !value || !author) {
      //   message.error('Please complete and correct the content!')
      //   return false
      // }
      return new Promise((res, rej) => {
        tourRef.current.validateFields().then((values) => {
          setPostting(true)
          request({
            method: 'post',
            url: '/api/message/add',
            data: {
              school_id: id,
              type: 2,
              ...values,
              subject: 'Schedule A Tour'
            }
          })
            .then((r) => {
              if (r.code === 0) {
                notification.success({
                  message:
                    'We are thrilled to receive your tour request! You will receive a confirmation email when the request goes out to the school. They will be in touch with you soon to schedule your tour!!'
                })
                setTourVisible(false)
                setUpdateChildrenDate(Date.now())
                setPostting(false)
                res(true)
              }
            })
            .catch(() => {
              setPostting(false)
              rej(false)
            })
        })
      })
    }
  }

  if (isShowCalendar) {
    tourModalOpt.footer = null
  }

  const requestModalOpt = {
    title: 'Request Rate',
    open: requestVisible,
    width: 500,
    onCancel() {
      setRequestVisible(false)
    },
    onOk() {
      return new Promise((res, rej) => {
        formRef.current
          .validateFields()
          .then((values) => {
            request({
              method: 'post',
              url: '/api/message/fee',
              data: {
                school_id: id,
                ...values
              }
            }).then((r) => {
              if (r.code === 0) {
                notification.success({
                  message:
                    'Thanks for submitting your request! Please check out your email for more details!!'
                })
                setRequestVisible(false)
                res(true)
              } else {
                message.error(r.msg)
                rej(false)
              }
            })
            res(true)
          })
          .catch((err) => {
            rej(err)
          })
      })
    }
  }

  const judgeIsPhoto = (src) => {
    const end = src ? src.split('.') : []
    if (end && end.length) {
      return (
        end[end.length - 1] === 'png' ||
        end[end.length - 1] === 'jpg' ||
        end[end.length - 1] === 'jpeg'
      )
    }
    return false
  }

  const judgeAnchorActive = useCallback(
    (r, i) => {
      if (i === anchorList.length - 1) {
        return nowScrollTop >= r.top ? styles.bodyLeftAnchorActive : ''
      } else {
        return nowScrollTop >= r.top - 50 &&
          nowScrollTop < anchorList[i + 1].top - 50
          ? styles.bodyLeftAnchorActive
          : ''
      }
    },
    [nowScrollTop, anchorList]
  )

  const onScheduleAtour = () => {
    if (detail.schedule_type === 3 && detail.tour_url) {
      window.open(detail.tour_url)
    } else {
      setTourVisible(true)
    }
  }

  const isEmpty = (arr) => {
    let v = '-'
    for (let index = 0; index < arr.length; index++) {
      const val = renderContentAutoLineFeed(detail[arr[index]])
      if (val !== '-') {
        v = val
      }
      break
    }
    return v === '-' ? true : false
  }

  const onClaim = () => {
    if (userInfo.id !== undefined) {
      if (judgeIsMySchool) {
        window.open(
          isOnlineDev
            ? `https://school.dev.ymontessori.com/editschool?token=${localStorage.getItem(
                'TOKEN'
              )}&school_index=${schoolIndex}`
            : `https://school.ymontessori.com/editschool?token=${localStorage.getItem(
                'TOKEN'
              )}&school_index=${schoolIndex}`
        )
      } else {
        setClaimShow(true)
      }
    } else {
      // 显示登陆
      dispatch(setSignShow(true))
    }
  }

  // 判断当前学校是否是我管理的
  const judgeIsMySchool = useMemo(() => {
    const schools = userInfo && userInfo.schools ? userInfo.schools : []
    return schools.filter((_) => _.id === detail.id).length > 0
  }, [userInfo])

  const onSave = () => {
    if (userInfo.id !== undefined) {
      request({
        url: isSave ? '/api/school/un-save' : '/api/school/save',
        method: 'POST',
        data: {
          school_id: detail.id
        }
      }).then((r) => {
        if (r.code === 0) {
          notification.success({
            message: `${isSave ? 'Unsave' : 'Save'} School Successfully!`
          })
          setUpdateSaveDate(Date.now())
          getDetail()
        }
      })
    } else {
      dispatch(setSignShow(true))
    }
  }

  return (
    <div>
      <Head>
        <title>
          {`${detail.name} - Y Montessori, Montessori School, Montessori Education,
          Montessori`}
        </title>
        <meta
          name="title"
          content={`${detail.name} - Y Montessori, Montessori School, Montessori Education, Montessori`}
        />
        <meta name="description" content={props.seoDesc}></meta>
        <meta name="keywords" content={props.seoKeyword}></meta>
      </Head>
      <main className={styles.container}>
        <Claim
          visible={claimShow}
          isClaimed={isClaimed}
          onCancel={setClaimShow}
          id={detail.id}
          email={detail.email}
          name={detail.name}
        ></Claim>

        {/* 评论弹窗 */}
        <Modal {...reviewModalOpt}>
          <div className={styles.modal}>
            <div className={styles.modalItem}>
              <div className={styles.modalItemHead}>* Overall experience</div>
              <div className={styles.modalItemBody}>
                <Rate
                  allowHalf
                  style={{ fontSize: 26 }}
                  value={reviewScore}
                  onChange={(r) => setReviewScore(r)}
                ></Rate>
              </div>
            </div>
            <div className={styles.modalItem}>
              <div className={styles.modalItemHead}>* Your Name</div>
              <div className={styles.modalItemBody}>
                <Input
                  value={author}
                  onChange={(e) => setAuthor(e.target.value)}
                  placeholder="Please input your name"
                />
              </div>
            </div>
            <div className={styles.modalItem} style={{ width: '100%' }}>
              <div className={styles.modalItemHead}>* Review</div>
              <div className={styles.modalItemBody}>
                <div id="toolbar-container">
                  <span className="ql-formats">
                    <select classclassName="ql-font"></select>
                    <select className="ql-size"></select>
                  </span>
                  <span className="ql-formats">
                    <button className="ql-bold"></button>
                    <button className="ql-italic"></button>
                    <button className="ql-underline"></button>
                    <button className="ql-strike"></button>
                  </span>
                  <span className="ql-formats">
                    <select className="ql-color"></select>
                    <select className="ql-background"></select>
                  </span>
                  <span className="ql-formats">
                    <button className="ql-script" value="sub"></button>
                    <button className="ql-script" value="super"></button>
                  </span>
                  <span className="ql-formats">
                    <button className="ql-header" value="1"></button>
                    <button className="ql-header" value="2"></button>
                    <button className="ql-blockquote"></button>
                    <button className="ql-code-block"></button>
                  </span>
                  <span className="ql-formats">
                    <button className="ql-list" value="ordered"></button>
                    <button className="ql-list" value="bullet"></button>
                    <button className="ql-indent" value="-1"></button>
                    <button className="ql-indent" value="+1"></button>
                  </span>
                </div>
                <ReactQuill
                  theme="snow"
                  className={styles.reactQuill}
                  value={value}
                  modules={{ toolbar: '#toolbar-container' }}
                  onChange={setValue}
                  placeholder="Tell us what you think about this school"
                />
              </div>
            </div>
          </div>
        </Modal>

        {/* Schedule a Tour */}
        <Modal {...tourModalOpt}>
          {isShowCalendar ? (
            <Calendar
              date={updateChildrenDate}
              onClose={() => setTourVisible(false)}
              id={detail.id}
              name={detail.name}
              scheduleCancel={scheduleCancel}
              scheduleReset={scheduleReset}
              sid={props.sid}
            ></Calendar>
          ) : (
            <div className={styles.modal}>
              <Form
                name="basic"
                layout="vertical"
                ref={tourRef}
                autoComplete="off"
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
              >
                <Row gutter={{ xl: 24 }}>
                  <Col sm={24} xl={8}>
                    <Form.Item
                      label="Full Name"
                      name="name"
                      rules={[
                        { required: true, message: 'Please input your name!' }
                      ]}
                    >
                      <Input placeholder="Full name" />
                    </Form.Item>
                  </Col>
                  <Col sm={24} xl={8}>
                    <Form.Item
                      label="Email"
                      name="email"
                      rules={[
                        { required: true, message: 'Please input your email!' },
                        {
                          type: 'email',
                          message: 'Please enter the correct email address!'
                        }
                      ]}
                    >
                      <Input placeholder="Email Address" />
                    </Form.Item>
                  </Col>
                  <Col sm={24} xl={8}>
                    <Form.Item
                      label="Phone Number"
                      name="tel"
                      rules={[
                        {
                          required: true,
                          message: 'Please input your phone number!'
                        },
                        {
                          len: 10
                        }
                      ]}
                    >
                      <Input
                        value={tel}
                        addonBefore="+1"
                        placeholder="Phone Number"
                        type="number"
                        maxLength={10}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={24}>
                    <Form.Item label="Message" name="content">
                      <Input.TextArea rows={6} />
                    </Form.Item>
                  </Col>
                </Row>
              </Form>
            </div>
          )}
        </Modal>

        {/* Request Rate */}
        <Modal {...requestModalOpt}>
          <Form name="basic" ref={formRef} autoComplete="off">
            <Form.Item
              label=""
              name="name"
              rules={[{ required: true, message: 'Please input your name!' }]}
            >
              <Input placeholder="* Full name" />
            </Form.Item>
            <Form.Item
              label=""
              name="email"
              rules={[
                { required: true, message: 'Please input your email!' },
                {
                  type: 'email',
                  message: 'Please enter the correct email address!'
                }
              ]}
            >
              <Input placeholder="* Email Address" />
            </Form.Item>
          </Form>
        </Modal>

        {/* 图片预览 */}
        <div style={{ display: 'none' }}>
          <Image.PreviewGroup
            preview={{
              visible: activeWatchImgVisible,
              onVisibleChange: (vis) => {
                setActiveWatchImgVisible(vis)
              }
            }}
          >
            {detail.imgs &&
              detail.imgs.map((_, i) => (
                <Image src={_} key={_} alt={`${detail.name}-${i}`}></Image>
              ))}
          </Image.PreviewGroup>
        </div>

        <div className={styles.main}>
          <div className={styles.head}>
            {/* 背景墙 */}
            <div className={styles.headImgBox}>
              <div className={styles.headImgBoxBtn}>
                {detail.imgs && detail.imgs.length ? (
                  <div
                    className={styles.headImgBoxBtnItem}
                    onClick={() => setActiveWatchImgVisible(true)}
                  >
                    <FileImageOutlined /> View all photos
                  </div>
                ) : (
                  ''
                )}
                <div className={styles.headImgBoxBtnItem} onClick={onClaim}>
                  <FormOutlined /> {judgeIsMySchool ? 'Edit' : 'Claim'} School
                </div>
                {/* <Dropdown
                  arrow
                  trigger={['click']}
                  menu={{ items: menus }}
                  placement="bottomRight"
                >
                  <div className={styles.headImgBoxBtnItem}>
                    <EllipsisOutlined />
                  </div>
                </Dropdown> */}
              </div>
              <div className={styles.headImgBoxLeft}>
                <div
                  className={styles.headImgBoxLeftItem}
                  style={{
                    background: `url(${
                      detail.imgs && detail.imgs.length
                        ? detail.imgs[0]
                        : '/detail-default-min.jpeg'
                    }) center center / cover no-repeat`
                  }}
                ></div>
                {/* <img src="https://s3.amazonaws.com/photos.niche.com/f71e14dee614b237302c6a1843171edbf7c1bb67"></img> */}
              </div>
              {detail.imgs && detail.imgs.length > 2 && (
                <div className={styles.headImgBoxRight}>
                  <div
                    className={styles.headImgBoxRightItem}
                    style={{
                      background: `url(${detail.imgs[1]}) center center / cover no-repeat`
                    }}
                  ></div>
                  <div
                    className={styles.headImgBoxRightItem}
                    style={{
                      background: `url(${detail.imgs[2]}) center center / cover no-repeat`
                    }}
                  ></div>
                </div>
              )}
            </div>

            {/* 基本信息 */}
            <div className={styles.headContent}>
              <div className={styles.headContentTop}>
                <img
                  className={styles.headContentTopLeft}
                  src={detail.icon || '/logo_new.jpeg'}
                  alt={detail.name}
                ></img>
                <div className={styles.headContentTopRight}>
                  <h1>{detail.name}　</h1>
                  <div className={styles.headDes}>
                    <div className={styles.headDesLeft}>
                      <div>
                        <Rate
                          disabled
                          allowHalf
                          value={+(detail.score / 2).toFixed(1)}
                        />
                        　(
                        {(detail.score / 2).toFixed(1)})
                      </div>
                      <div style={{ padding: '5px 0 0 15px' }}>
                        <b>{detail.review_count}</b> Reviews
                      </div>
                    </div>
                    <div className={styles.headDesRight}>
                      <Button type="primary" onClick={onScheduleAtour}>
                        <img
                          src="/message.png"
                          style={{ width: 35 }}
                          alt="message"
                        />
                        <p>Schedule a Tour</p>
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
              <div className={styles.headTags}>
                {detail.home_based_or_center_based && (
                  <div className={styles.headTags1}>
                    {detail.home_based_or_center_based}
                  </div>
                )}
                <div className={styles.headTags2}>
                  Capacity: {detail.total_capacity}
                </div>
                {detail.accreditation && (
                  <div className={styles.headTags3}>
                    {detail.accreditation.trim()}
                  </div>
                )}
                {detail.operation_hours && (
                  <div className={styles.headTags4}>
                    {detail.operation_hours}
                  </div>
                )}
                {isClaimed ? (
                  <Tag
                    color="#87d068"
                    style={{ marginBottom: 10 }}
                    onClick={onClaim}
                  >
                    Claimed
                  </Tag>
                ) : (
                  <Tag
                    color="#F99B7D"
                    style={{ marginBottom: 10 }}
                    onClick={onClaim}
                  >
                    Unclaimed
                  </Tag>
                )}
                {detail.operating_status &&
                  detail.operating_status.indexOf('Closed') > -1 && (
                    <Tag color="#ccc" style={{ marginBottom: 10 }}>
                      {detail.operating_status}
                    </Tag>
                  )}
              </div>
            </div>
          </div>
          <div className={styles.body} id="body">
            {/* 主体内容-左 */}
            <div className={styles.bodyLeft}>
              <div className={styles.bodyLeftOption}>
                <div
                  className={styles.bodyLeftOptionItem}
                  onClick={() => setReviewVisible(true)}
                >
                  <div
                    className={styles.bodyLeftOptionItemImg}
                    style={{
                      backgroundImage: `url('/brush.svg')`,
                      backgroundSize: '22px',
                      backgroundRepeat: 'no-repeat',
                      backgroundPosition: 'center'
                    }}
                  ></div>
                  <div className={styles.bodyLeftOptionItemText}>Review</div>
                </div>
                <div className={styles.bodyLeftOptionItem} onClick={onSave}>
                  <div
                    className={styles.bodyLeftOptionItemImg}
                    style={{
                      backgroundImage: `url('/${
                        isSave ? 'unlike' : 'like'
                      }.svg')`,
                      backgroundSize: '22px',
                      backgroundRepeat: 'no-repeat',
                      backgroundPosition: 'center'
                    }}
                  ></div>
                  <div className={styles.bodyLeftOptionItemText}>
                    {isSave ? 'Unsave' : 'Save'}
                  </div>
                </div>
                <div
                  className={styles.bodyLeftOptionItem}
                  onClick={() =>
                    Modal.info({
                      title: 'Coming soon. Stay tuned!'
                    })
                  }
                >
                  <div
                    className={styles.bodyLeftOptionItemImg}
                    style={{
                      backgroundImage: `url('/compare.svg')`,
                      backgroundSize: '20px',
                      backgroundRepeat: 'no-repeat',
                      backgroundPosition: 'center'
                    }}
                  ></div>
                  <div className={styles.bodyLeftOptionItemText}>Compare</div>
                </div>
              </div>
              <div className={styles.bodyLeftAnchor}>
                {anchorList.map((_, i) => (
                  <a
                    href={`#${_.id}`}
                    title={_.title}
                    className={judgeAnchorActive(_, i)}
                    key={_.id}
                  >
                    {_.title}
                  </a>
                ))}
              </div>
            </div>
            {/* 主体内容-右 */}
            <div className={styles.bodyRight} id="scroll">
              <div className={styles.item} id="About">
                <div className={styles.itemHead}>ABOUT</div>
                <div className={styles.itemBox}>
                  <div className={styles.itemBoxLeft}>
                    <div className={styles.itemBoxLeftContent}>
                      <GlobalOutlined />{' '}
                      <p>
                        <a href={detail.website} target="__blank">
                          {(detail.website &&
                            detail.website
                              .replace(/https?:\/\//g, '')
                              .split('/')[0]) ||
                            '-'}
                        </a>
                      </p>
                    </div>
                    <div className={styles.itemBoxLeftContent}>
                      <PhoneOutlined />{' '}
                      <p>
                        <a
                          target="__blank"
                          href={`tel:${
                            detail.phone_number &&
                            detail.phone_number.replace(/\D/g, '')
                          }`}
                        >
                          {(detail.phone_number &&
                            detail.phone_number.trim()) ||
                            '-'}
                        </a>
                      </p>
                    </div>
                    <div className={styles.itemBoxLeftContent}>
                      <MailOutlined /> <p>{detail.email || '-'}</p>
                    </div>
                    <div className={styles.itemBoxLeftContent}>
                      <EnvironmentOutlined />{' '}
                      <p>
                        {detail.street_address && (
                          <span>{detail.street_address}, </span>
                        )}
                        {detail.locality && <span>{detail.locality}, </span>}
                        {detail.state && <span>{detail.state}, </span>}
                        {detail.zip_code}
                      </p>
                    </div>
                    <div className={styles.itemBoxLeftContent}>
                      {detail.facebook && (
                        <div
                          className={styles.itemBoxLeftContentLabel1}
                          onClick={() => window.open(detail.facebook)}
                        >
                          <img src="/facebook.svg" alt="facebook" />
                          <span>Facebook</span>
                        </div>
                      )}
                      {detail.instagram && (
                        <div
                          className={styles.itemBoxLeftContentLabel2}
                          onClick={() => window.open(detail.instagram)}
                        >
                          <img src="/instagram.svg" alt="instagram" />
                          <span>Instagram</span>
                        </div>
                      )}
                    </div>
                  </div>
                  <div className={styles.itemBoxRight}>
                    {typeof window !== 'undefined' && window.google ? (
                      <GoogleMap
                        center={[
                          parseFloat(detail.latitude) || 33.155689,
                          parseFloat(detail.longitude) || -117.341972
                        ]}
                        defaultZoom={15}
                      >
                        <Maker
                          lat={parseFloat(detail.latitude) || 33.155689}
                          lng={parseFloat(detail.longitude) || -117.341972}
                          active={true}
                          name={detail.name}
                        ></Maker>
                      </GoogleMap>
                    ) : null}
                  </div>
                </div>
              </div>

              <div className={styles.item} id="Destination">
                <div className={styles.itemHead}>DESCRIPTION</div>
                <div
                  className={styles.itemContent}
                  style={{ fontSize: 16 }}
                  dangerouslySetInnerHTML={{
                    __html: (detail.description ?? '-').replace(/\n/g, '<br />')
                  }}
                ></div>
              </div>

              <div className={styles.item} id="General">
                <div className={styles.itemHead}>GENERAL INFOMATION</div>
                <div
                  className={styles.itemBox}
                  style={{ flexDirection: 'column', padding: '0 15px' }}
                >
                  {renderContentAutoLineFeed(
                    detail.home_based_or_center_based
                  ) !== '-' && (
                    <div className={styles.itemBoxContent}>
                      <div className={styles.itemBoxContentLeft}>
                        Facility Type
                      </div>
                      <div className={styles.itemBoxContentRight}>
                        {renderContentAutoLineFeed(
                          detail.home_based_or_center_based
                        )}
                      </div>
                    </div>
                  )}

                  {renderContentAutoLineFeed(detail.total_capacity) !== '-' && (
                    <div className={styles.itemBoxContent}>
                      <div className={styles.itemBoxContentLeft}>
                        Total Capacity
                      </div>
                      <div className={styles.itemBoxContentRight}>
                        {renderContentAutoLineFeed(detail.total_capacity)}
                      </div>
                    </div>
                  )}

                  {renderContentAutoLineFeed(detail.accreditation_detail) !==
                    '-' && (
                    <div className={styles.itemBoxContent}>
                      <div className={styles.itemBoxContentLeft}>
                        Accreditation Details{' '}
                        <QuestionCircleFilled
                          className={styles.question}
                          onClick={(e) => {
                            e.stopPropagation()
                            window.open(
                              '/resources#How-do-I-interpret-the-Accreditation-status-and-why-it-matters?-'
                            )
                          }}
                        />
                      </div>
                      <div className={styles.itemBoxContentRight}>
                        {renderContentAutoLineFeed(detail.accreditation_detail)}
                      </div>
                    </div>
                  )}

                  {detail.age_min !== 0 && detail.age_max !== 0 ? (
                    <div className={styles.itemBoxContent}>
                      <div className={styles.itemBoxContentLeft}>Age</div>
                      <div className={styles.itemBoxContentRight}>
                        {dealAgeMin(detail.age_min)} - {detail.age_max} yr
                      </div>
                    </div>
                  ) : null}

                  {detail.operation_hours && (
                    <div className={styles.itemBoxContent}>
                      <div className={styles.itemBoxContentLeft}>Hours</div>
                      <div className={styles.itemBoxContentRight}>
                        {detail.operation_hours || '-'}
                      </div>
                    </div>
                  )}
                  {renderContentAutoLineFeed(detail.bilingual_program) !==
                    '-' && (
                    <div className={styles.itemBoxContent}>
                      <div className={styles.itemBoxContentLeft}>
                        Bilingual Program
                      </div>
                      <div className={styles.itemBoxContentRight}>
                        {renderContentAutoLineFeed(detail.bilingual_program)}
                      </div>
                    </div>
                  )}
                </div>
              </div>

              {/* Daily SCHEDULES */}
              {isEmpty([
                'lunch_provided',
                'snack_provided',
                'outside_playtime',
                'naptime',
                'daily_updates',
                'after_school_program',
                'enrichment_classes'
              ]) ? null : (
                <div className={styles.item} id="Daily">
                  <div className={styles.itemHead}>DAILY SCHEDULES</div>
                  <div
                    className={styles.itemBox}
                    style={{ flexDirection: 'column', padding: '0 15px' }}
                  >
                    {renderContentAutoLineFeed(detail.lunch_provided) !==
                      '-' && (
                      <div className={styles.itemBoxContent}>
                        <div className={styles.itemBoxContentLeft}>Lunch</div>
                        <div className={styles.itemBoxContentRight}>
                          {renderContentAutoLineFeed(detail.lunch_provided)}
                        </div>
                      </div>
                    )}

                    {renderContentAutoLineFeed(detail.snack_provided) !==
                      '-' && (
                      <div className={styles.itemBoxContent}>
                        <div className={styles.itemBoxContentLeft}>Snack</div>
                        <div className={styles.itemBoxContentRight}>
                          {renderContentAutoLineFeed(detail.snack_provided)}
                        </div>
                      </div>
                    )}

                    {renderContentAutoLineFeed(detail.outside_playtime) !==
                      '-' && (
                      <div className={styles.itemBoxContent}>
                        <div className={styles.itemBoxContentLeft}>
                          Outside Playtime
                        </div>
                        <div className={styles.itemBoxContentRight}>
                          {renderContentAutoLineFeed(detail.outside_playtime)}
                        </div>
                      </div>
                    )}

                    {renderContentAutoLineFeed(detail.naptime) !== '-' && (
                      <div className={styles.itemBoxContent}>
                        <div className={styles.itemBoxContentLeft}>Naptime</div>
                        <div className={styles.itemBoxContentRight}>
                          {renderContentAutoLineFeed(detail.naptime)}
                        </div>
                      </div>
                    )}

                    {renderContentAutoLineFeed(detail.daily_updates) !==
                      '-' && (
                      <div className={styles.itemBoxContent}>
                        <div className={styles.itemBoxContentLeft}>
                          Daily Updates
                        </div>
                        <div className={styles.itemBoxContentRight}>
                          {renderContentAutoLineFeed(detail.daily_updates)}
                        </div>
                      </div>
                    )}

                    {renderContentAutoLineFeed(detail.after_school_program) !==
                      '-' && (
                      <div className={styles.itemBoxContent}>
                        <div className={styles.itemBoxContentLeft}>
                          Afterschool Program
                        </div>
                        <div className={styles.itemBoxContentRight}>
                          {renderContentAutoLineFeed(
                            detail.after_school_program
                          )}
                        </div>
                      </div>
                    )}

                    {renderContentAutoLineFeed(detail.enrichment_classes) !==
                      '-' && (
                      <div className={styles.itemBoxContent}>
                        <div className={styles.itemBoxContentLeft}>
                          Enrichment Program
                        </div>
                        <div className={styles.itemBoxContentRight}>
                          {renderContentAutoLineFeed(detail.enrichment_classes)}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              )}

              {/* FEES & DISCOUNT */}
              {isEmpty(['discount', 'fees']) ? null : (
                <div className={styles.item} id="AllAbout">
                  <div className={styles.itemHead}>FEES & DISCOUNT</div>
                  <div
                    className={styles.itemBox}
                    style={{ flexDirection: 'column', padding: '0 15px' }}
                  >
                    <div className={styles.itemBoxContent}>
                      <div className={styles.itemBoxContentLeft}>Discounts</div>
                      <div className={styles.itemBoxContentRight}>
                        {detail.discount
                          ? detail.discount === +detail.discount
                            ? `${+detail.discount * 100}%`
                            : renderContentAutoLineFeed(detail.discount)
                          : '-'}
                      </div>
                    </div>
                    <div className={styles.itemBoxContent}>
                      <div className={styles.itemBoxContentLeft}>Fees</div>
                      <div className={styles.itemBoxContentRight}>
                        {renderContentAutoLineFeed(detail.fees)}
                      </div>
                    </div>
                  </div>
                </div>
              )}

              <div className={styles.item} id="Schedules">
                <div className={styles.itemHead}>SCHEDULES AVALIBLE</div>
                <div
                  className={styles.itemBox}
                  style={{
                    flexDirection: 'column',
                    alignItems: 'flex-start'
                  }}
                >
                  {isPhone ? (
                    <Table2phone
                      columns={schedulesAvalibleColumns}
                      dataSource={schedulesAvalibleDataSource}
                    />
                  ) : (
                    <Table
                      style={{ width: '100%' }}
                      bordered
                      columns={schedulesAvalibleColumns}
                      dataSource={schedulesAvalibleDataSource}
                      pagination={false}
                      rowKey="schedule"
                    ></Table>
                  )}
                  <div
                    className={styles.itemBoxExtend}
                    style={{ padding: '15px 0', width: '100%' }}
                  >
                    {detail.extended_care && (
                      <>
                        <p
                          style={{
                            marginBottom: 5,
                            fontSize: 16,
                            color: '#999'
                          }}
                        >
                          Extended Care:{' '}
                        </p>
                        <p
                          style={{
                            background: '#f5f5f5',
                            padding: 10,
                            borderRadius: 3
                          }}
                          dangerouslySetInnerHTML={{
                            __html: detail.extended_care.replace(/;/g, '<br />')
                          }}
                        ></p>
                      </>
                    )}
                    {detail.extended_care_fee && (
                      <>
                        <p
                          style={{
                            marginBottom: 5,
                            fontSize: 16,
                            color: '#999'
                          }}
                        >
                          Option for Hourly Care:{' '}
                        </p>
                        <p
                          style={{
                            background: '#f5f5f5',
                            padding: 10,
                            borderRadius: 3
                          }}
                          dangerouslySetInnerHTML={{
                            __html: detail.extended_care_fee.replace(
                              /;/g,
                              '<br />'
                            )
                          }}
                        ></p>
                      </>
                    )}
                  </div>
                </div>
              </div>

              <div className={styles.item} id="Offered">
                <div className={styles.itemHead}>PROGRAMS OFFERED</div>
                <div className={styles.itemBox}>{renderPannel}</div>
              </div>

              {detail.school_calendar !== '' && (
                <div className={styles.item} id="Calender">
                  <div className={styles.itemHead}>SCHOOL CALENDER</div>
                  <div
                    className={styles.itemBox}
                    style={{
                      flexDirection: 'column',
                      padding: '0 15px',
                      cursor:
                        detail.school_calendar !== '' ? 'pointer' : 'inherit'
                    }}
                  >
                    {detail.school_calendar !== '' ? (
                      judgeIsPhoto(detail.school_calendar) ? (
                        <Image
                          src={detail.school_calendar}
                          alt={`${detail.name} calendar`}
                        ></Image>
                      ) : (
                        <EmbedPDF>
                          <a
                            href={detail.school_calendar}
                            style={{ display: 'block', width: '100%' }}
                          >
                            <object
                              data={detail.school_calendar}
                              type="application/pdf"
                              width="100%"
                              height={600}
                            >
                              <p style={{ textAlign: 'center' }}>
                                Unable to display PDF file.{' '}
                                <EmbedPDF>
                                  <a href={detail.school_calendar}>Download</a>
                                </EmbedPDF>{' '}
                                instead.
                              </p>
                            </object>
                          </a>
                        </EmbedPDF>
                        // <PdfViewer
                        //   url={detail.school_calendar}
                        //   pageNumber={1}
                        // ></PdfViewer>
                      )
                    ) : (
                      <div
                        className={styles.itemBoxContent}
                        style={{
                          textAlign: 'center',
                          justifyContent: 'center',
                          color: '#999'
                        }}
                      >
                        No School Calendar
                      </div>
                    )}
                  </div>
                </div>
              )}
              {/* <div className={styles.item} id="Details">
                <div className={styles.itemHead}>Programs Details</div>
              </div> */}
              <div className={styles.review} id="Review">
                <div className={styles.reviewHead}>
                  <div className={styles.reviewHeadLeft}>
                    <div className={styles.reviewHeadLeftScore}>
                      {(detail.score / 2).toFixed(1)}
                    </div>
                    <Rate
                      className={styles.reviewHeadLeftStar}
                      disabled
                      allowHalf
                      value={+(detail.score / 2).toFixed(1)}
                    />
                    <div className={styles.reviewHeadLeftNum}>
                      {detail.review_count} Reviews
                    </div>
                  </div>
                  <div className={styles.reviewHeadRight}>
                    <div className={styles.reviewHeadRightRate}>
                      <div className={styles.reviewHeadRightRateItem}>
                        <div
                          className={styles.reviewHeadRightRateItemActiveColor}
                          style={{
                            width: `${countReviewLength(getReviewCount(8, 9))}%`
                          }}
                        ></div>
                        <div className={styles.reviewHeadRightRateItemContent}>
                          <Rate
                            className={styles.reviewHeadRightRateItemRate}
                            disabled
                            allowHalf
                            value={5}
                          />
                          {/* 　Excellent */}
                        </div>
                        <span className={styles.reviewHeadRightRateItemNum}>
                          {getReviewCount(8, 9)}
                        </span>
                      </div>
                      <div className={styles.reviewHeadRightRateItem}>
                        <div
                          className={styles.reviewHeadRightRateItemActiveColor}
                          style={{
                            width: `${countReviewLength(getReviewCount(6, 7))}%`
                          }}
                        ></div>
                        <div className={styles.reviewHeadRightRateItemContent}>
                          <Rate
                            className={styles.reviewHeadRightRateItemRate}
                            disabled
                            allowHalf
                            value={4}
                          />
                          {/* 　Very Good */}
                        </div>
                        <span className={styles.reviewHeadRightRateItemNum}>
                          {getReviewCount(6, 7)}
                        </span>
                      </div>
                      <div className={styles.reviewHeadRightRateItem}>
                        <div
                          className={styles.reviewHeadRightRateItemActiveColor}
                          style={{
                            width: `${countReviewLength(getReviewCount(4, 5))}%`
                          }}
                        ></div>
                        <div className={styles.reviewHeadRightRateItemContent}>
                          <Rate
                            className={styles.reviewHeadRightRateItemRate}
                            disabled
                            allowHalf
                            value={3}
                          />
                          {/* 　Average */}
                        </div>
                        <span className={styles.reviewHeadRightRateItemNum}>
                          {getReviewCount(4, 5)}
                        </span>
                      </div>
                      <div className={styles.reviewHeadRightRateItem}>
                        <div
                          className={styles.reviewHeadRightRateItemActiveColor}
                          style={{
                            width: `${countReviewLength(getReviewCount(2, 3))}%`
                          }}
                        ></div>
                        <div className={styles.reviewHeadRightRateItemContent}>
                          <Rate
                            className={styles.reviewHeadRightRateItemRate}
                            disabled
                            allowHalf
                            value={2}
                          />
                          {/* 　Poor */}
                        </div>
                        <span className={styles.reviewHeadRightRateItemNum}>
                          {getReviewCount(2, 3)}
                        </span>
                      </div>
                      <div className={styles.reviewHeadRightRateItem}>
                        <div
                          className={styles.reviewHeadRightRateItemActiveColor}
                          style={{
                            width: `${countReviewLength(getReviewCount(0, 1))}%`
                          }}
                        ></div>
                        <div className={styles.reviewHeadRightRateItemContent}>
                          <Rate
                            className={styles.reviewHeadRightRateItemRate}
                            disabled
                            allowHalf
                            value={1}
                          />
                          {/* 　Terrible */}
                        </div>
                        <span className={styles.reviewHeadRightRateItemNum}>
                          {getReviewCount(0, 1)}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className={styles.reviewBtn}>
                  <Button type="primary" onClick={() => setReviewVisible(true)}>
                    Write a Review
                  </Button>
                </div>

                {isPhone ? (
                  <div className={styles.reviewTabs}>
                    <>
                      <div className={styles.reviewPhoneTabsTitle}>
                        YMontessori
                      </div>
                      {reviews.data && reviews.data.length ? (
                        <div className={styles.reviewList}>
                          {reviews.data.map((_) => (
                            <div className={styles.reviewListItem} key={_.id}>
                              <div className={styles.reviewListItemLeft}>
                                <img
                                  alt={_.author_name}
                                  src="data:image/png;base64,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"
                                />
                              </div>
                              <div className={styles.reviewListItemRight}>
                                <div className={styles.reviewListItemRightName}>
                                  {_.author_name}
                                </div>
                                <div className={styles.reviewListItemRightDes}>
                                  <Rate
                                    className={
                                      styles.reviewListItemRightDesRate
                                    }
                                    disabled
                                    allowHalf
                                    value={+(_.score / 2).toFixed(1)}
                                  />
                                  　{_.create_time}
                                </div>
                                <div
                                  className={styles.reviewListItemRightContent}
                                >
                                  <div
                                    dangerouslySetInnerHTML={{
                                      __html: _.content
                                    }}
                                  ></div>
                                </div>
                              </div>
                            </div>
                          ))}
                          {reviews.data &&
                            reviews.data.length < reviews.total && (
                              <div
                                className={styles.reviewListMore}
                                onClick={getRivewList.bind(null, true)}
                              >
                                See More Reviews
                              </div>
                            )}
                        </div>
                      ) : (
                        <div className={styles.noContent}>No Reviews</div>
                      )}
                    </>
                    <>
                      <div className={styles.reviewPhoneTabsTitle}>Google</div>
                      <div className={styles.reviewList}>
                        {googleReviewList && googleReviewList.length ? (
                          googleReviewList.map((_) => (
                            <div className={styles.reviewListItem} key={_.id}>
                              <div className={styles.reviewListItemLeft}>
                                <img
                                  alt={_.author_name}
                                  style={{ width: 50 }}
                                  src={
                                    _.author_avatar ||
                                    'data:image/png;base64,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'
                                  }
                                />
                              </div>
                              <div className={styles.reviewListItemRight}>
                                <div className={styles.reviewListItemRightName}>
                                  {_.author_name}
                                </div>
                                <div className={styles.reviewListItemRightDes}>
                                  <Rate
                                    className={
                                      styles.reviewListItemRightDesRate
                                    }
                                    disabled
                                    allowHalf
                                    value={+(_.score / 2).toFixed(1)}
                                  />
                                  　{_.create_time}
                                </div>
                                <div
                                  className={styles.reviewListItemRightContent}
                                >
                                  <div
                                    dangerouslySetInnerHTML={{
                                      __html: _.content
                                    }}
                                  ></div>
                                </div>
                              </div>
                            </div>
                          ))
                        ) : (
                          <div className={styles.noContent}>No Reviews</div>
                        )}
                        {detail.review_detail.gg[0] > 0 && (
                          <a
                            className={styles.reviewListMore}
                            href={`${props.googleReviewUrl}`}
                            target="_blank"
                          >
                            See More Reviews
                          </a>
                        )}
                      </div>
                    </>
                    <>
                      <div className={styles.reviewPhoneTabsTitle}>Yelp</div>
                      <div className={styles.reviewTabsYelp}>
                        {yelpReviewList &&
                        yelpReviewList.filter((_) => _.source_id !== '')
                          .length ? (
                          <div>
                            <Script
                              async
                              src="https://www.yelp.com/embed/widgets.js"
                            ></Script>
                            <Carousel
                              initialSlide={yelpCurrent}
                              arrows
                              prevArrow={
                                <SlickButtonFix>
                                  <div>
                                    <LeftOutlined
                                      className={
                                        yelpCurrent === 0
                                          ? styles.reviewTabsYelpDisabled
                                          : null
                                      }
                                    />
                                  </div>
                                </SlickButtonFix>
                              }
                              nextArrow={
                                <SlickButtonFix>
                                  <div style={{ top: '90%', right: 10 }}>
                                    <RightOutlined
                                      className={
                                        yelpCurrent === yelpReviews.total - 1
                                          ? styles.reviewTabsYelpDisabled
                                          : null
                                      }
                                      onClick={getYelpReview}
                                    />
                                  </div>
                                </SlickButtonFix>
                              }
                              afterChange={(current) => setYelpCurrent(current)}
                            >
                              {yelpReviewList
                                .filter((_) => _.source_id !== '')
                                .map((_) => (
                                  <iframe
                                    key={_.source_id}
                                    data-review-id={_.source_id}
                                    className="yelp-review"
                                    src={`https://www.yelp.com/embed/review/${_.source_id}`}
                                    style={{ minHeight: 350 }}
                                  ></iframe>
                                ))}
                            </Carousel>
                          </div>
                        ) : (
                          <div className={styles.noContent}>No Reviews</div>
                        )}
                      </div>
                    </>
                  </div>
                ) : (
                  <Tabs
                    defaultActiveKey="1"
                    className={styles.reviewTabs}
                    items={[
                      {
                        label: (
                          <div
                            style={{ display: 'flex', alignItems: 'center' }}
                          >
                            <img
                              width={24}
                              style={{ marginRight: 10 }}
                              src="/yelp.png"
                              alt="yelp"
                            />
                            <b>
                              Yelp (
                              {detail.review_detail
                                ? detail.review_detail.yp[0]
                                : yelpReviews.total}
                              )
                            </b>
                          </div>
                        ),
                        key: '1',
                        children: (
                          <div className={styles.reviewTabsYelp}>
                            {yelpReviewList &&
                            yelpReviewList.filter((_) => _.source_id !== '')
                              .length ? (
                              <div>
                                <Script
                                  async
                                  src="https://www.yelp.com/embed/widgets.js"
                                ></Script>
                                <Carousel
                                  initialSlide={yelpCurrent}
                                  arrows
                                  prevArrow={
                                    <SlickButtonFix>
                                      <div>
                                        <LeftOutlined
                                          className={
                                            yelpCurrent === 0
                                              ? styles.reviewTabsYelpDisabled
                                              : null
                                          }
                                        />
                                      </div>
                                    </SlickButtonFix>
                                  }
                                  nextArrow={
                                    <SlickButtonFix>
                                      <div style={{ top: '90%', right: 10 }}>
                                        <RightOutlined
                                          className={
                                            yelpCurrent ===
                                            yelpReviews.total - 1
                                              ? styles.reviewTabsYelpDisabled
                                              : null
                                          }
                                          onClick={getYelpReview}
                                        />
                                      </div>
                                    </SlickButtonFix>
                                  }
                                  afterChange={(current) =>
                                    setYelpCurrent(current)
                                  }
                                >
                                  {yelpReviewList
                                    .filter((_) => _.source_id !== '')
                                    .map((_) => (
                                      <iframe
                                        key={_.source_id}
                                        data-review-id={_.source_id}
                                        className="yelp-review"
                                        src={`https://www.yelp.com/embed/review/${_.source_id}`}
                                        style={{ minHeight: 350 }}
                                      ></iframe>
                                    ))}
                                </Carousel>
                              </div>
                            ) : (
                              <div className={styles.noContent}>No Reviews</div>
                            )}
                          </div>
                        )
                      },
                      {
                        label: (
                          <div
                            style={{ display: 'flex', alignItems: 'center' }}
                          >
                            <img
                              width={24}
                              style={{ marginRight: 10 }}
                              src="/google.png"
                              alt="google"
                            />
                            <b>
                              Google (
                              {detail.review_detail
                                ? detail.review_detail.gg[0]
                                : googleReviews.total}
                              )
                            </b>
                          </div>
                        ),
                        key: '2',
                        children: (
                          <div className={styles.reviewList}>
                            {googleReviewList && googleReviewList.length ? (
                              googleReviewList.map((_) => (
                                <div
                                  className={styles.reviewListItem}
                                  key={_.id}
                                >
                                  <div className={styles.reviewListItemLeft}>
                                    <img
                                      alt={_.author_name}
                                      style={{ width: 50 }}
                                      src={
                                        _.author_avatar ||
                                        'data:image/png;base64,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'
                                      }
                                    />
                                  </div>
                                  <div className={styles.reviewListItemRight}>
                                    <div
                                      className={styles.reviewListItemRightName}
                                    >
                                      {_.author_name}
                                    </div>
                                    <div
                                      className={styles.reviewListItemRightDes}
                                    >
                                      <Rate
                                        className={
                                          styles.reviewListItemRightDesRate
                                        }
                                        disabled
                                        allowHalf
                                        value={+(_.score / 2).toFixed(1)}
                                      />
                                      　{_.create_time}
                                    </div>
                                    <div
                                      className={
                                        styles.reviewListItemRightContent
                                      }
                                    >
                                      <div
                                        dangerouslySetInnerHTML={{
                                          __html: _.content
                                        }}
                                      ></div>
                                    </div>
                                  </div>
                                </div>
                              ))
                            ) : (
                              <div className={styles.noContent}>No Reviews</div>
                            )}
                            {detail.review_detail.gg[0] > 0 && (
                              <a
                                className={styles.reviewListMore}
                                href={`${props.googleReviewUrl}`}
                                target="_blank"
                              >
                                See More Reviews
                              </a>
                            )}
                          </div>
                        )
                      },
                      {
                        label: (
                          <div
                            style={{ display: 'flex', alignItems: 'center' }}
                          >
                            <img
                              width={24}
                              style={{ marginRight: 10 }}
                              src="/logo_new.png"
                              alt="Y Montessori"
                            />
                            <b>
                              Y Montessori (
                              {detail.review_detail
                                ? detail.review_detail.mt[0]
                                : reviews.total}
                              )
                            </b>
                          </div>
                        ),
                        key: '3',
                        children:
                          reviews.data && reviews.data.length ? (
                            <div className={styles.reviewList}>
                              {reviews.data.map((_) => (
                                <div
                                  className={styles.reviewListItem}
                                  key={_.id}
                                >
                                  <div className={styles.reviewListItemLeft}>
                                    <img
                                      alt={_.author_name}
                                      src="data:image/png;base64,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"
                                    />
                                  </div>
                                  <div className={styles.reviewListItemRight}>
                                    <div
                                      className={styles.reviewListItemRightName}
                                    >
                                      {_.author_name}
                                    </div>
                                    <div
                                      className={styles.reviewListItemRightDes}
                                    >
                                      <Rate
                                        className={
                                          styles.reviewListItemRightDesRate
                                        }
                                        disabled
                                        allowHalf
                                        value={+(_.score / 2).toFixed(1)}
                                      />
                                      　{_.create_time}
                                    </div>
                                    <div
                                      className={
                                        styles.reviewListItemRightContent
                                      }
                                    >
                                      <div
                                        dangerouslySetInnerHTML={{
                                          __html: _.content
                                        }}
                                      ></div>
                                    </div>
                                  </div>
                                </div>
                              ))}
                              {reviews.data &&
                                reviews.data.length < reviews.total && (
                                  <div
                                    className={styles.reviewListMore}
                                    onClick={getRivewList.bind(null, true)}
                                  >
                                    See More Reviews
                                  </div>
                                )}
                            </div>
                          ) : (
                            <div className={styles.noContent}>No Reviews</div>
                          )
                      }
                    ]}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  )
}

export async function getServerSideProps({ query }) {
  const { redirect } = require('../../server/utils')

  let reviews = {}
  let yelpReviews = {}
  let googleReviews = {}
  let googleReviewUrl = null
  console.log(
    `${process.env.NEXT_PUBLIC_API}/api/school/detail?url=${query.id}`
  )
  const response = await fetch(
    `${process.env.NEXT_PUBLIC_API}/api/school/detail?url=${query.id}`
  )
  let { data: detail } = await response.json()
  if (detail && detail.id) {
    const reviewRes = await fetch(
      `${process.env.NEXT_PUBLIC_API}/api/review/list?school_id=${detail.id}&per_page=10&page=1&source=0`
    )
    const yelpReviewRes = await fetch(
      `${process.env.NEXT_PUBLIC_API}/api/review/list?school_id=${detail.id}&per_page=2&page=1&source=1`
    )
    const googleReviewRes = await fetch(
      `${process.env.NEXT_PUBLIC_API}/api/review/list?school_id=${detail.id}&source=2`
    )
    const { data } = await reviewRes.json()
    const { data: yelpData } = await yelpReviewRes.json()
    const { data: googleData, more_url } = await googleReviewRes.json()
    reviews = data
    yelpReviews = yelpData
    googleReviews = googleData
    if (more_url) {
      googleReviewUrl = more_url
    }
  } else {
    detail = { imgs: [] }
  }

  return redirect(query.id)
    ? redirect(query.id)
    : {
        props: {
          id: query.id,
          scheduleCancel: query.schedule_cancel || null,
          scheduleReset: query.schedule_reset || null,
          tourVisible: !!query.schedule,
          sid: query.sid || null,
          detail:
            {
              ...detail,
              review_detail: detail.review_detail || {
                gg: [0],
                yp: [0],
                mt: [0]
              }
            } || {},
          reviews,
          yelpReviews,
          googleReviews,
          googleReviewUrl,
          seoDesc: `${detail.review_count} reviews of ${
            detail.name
          } • located at ${
            detail.street_address ? `${detail.street_address},` : ''
          }${detail.locality ? `${detail.locality},` : ''}${
            detail.state ? `${detail.state},` : ''
          }${detail.zip_code ? `${detail.zip_code},` : ''} • ${
            detail.home_based_or_center_based
          } school that provides Montessori education for children aged ${dealAgeMin(
            detail.age_min
          )} - ${detail.age_max}yr. With a total capacity of ${
            detail.total_capacity
          } • we operate during the following hours: ${
            detail.operation_hours
          } • For additional information • We are thrilled to announce our presence on the Y Montessori website and invite you to schedule a tour with us.`,
          seoKeyword: `${detail.name}, ${detail.street_address}, ${
            detail.locality
          }, ${detail.state}, ${detail.zip_code}, ${
            detail.home_based_or_center_based
          }, ${detail.accreditation}, ${detail.bilingual_program}, ${dealAgeMin(
            detail.age_min
          )} - ${
            detail.age_max
          }yr, infant, toddler, primary, nido, elementary, middle, middle school, high, high school, nap time, potty training, half day, full day, full time, part time, 2 day, 3 day, 5 day, Montessori classroom, Montessori materials, why choose Montessori, benefits of Montessori, Montessori parents, Montessori children, montessori school, montesori education, ami, ams`
        }
      }
}
